<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<vue3-tags-input
			:tags="model"
			placeholder="入力後、Enterを押してください"
			class="input w-full"
			:class="disabled ? 'disabled' : ''"
			:read-only="disabled"
			@on-tags-changed="handleChangeTag"
		/>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { onMounted, ref, watch } from "vue";

/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	type: String,
	title: String,
	text: String,
	formClass: [String, Array],
	maxlength: Number,
	placeholder: String,
	disabled: Boolean,
	required: Boolean,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();

const handleChangeTag = newTags => {
	model.value = newTags;
};
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");

/* ---------------------------------------------------------------------------
	modelValueの値を監視
---------------------------------------------------------------------------- */
watch(
	() => model.value,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */

function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	テキストタイプがnumberの場合、数値以外の文字列が入ったら削除
---------------------------------------------------------------------------- */
function checkInput(input) {
	if (props.type == "number") {
		let value = input.value;
		if (input.value === "") {
			input.type = "text";
			input.value = "";
		} else {
			value = value.replace(/[０-９]/g, s =>
				String.fromCharCode(s.charCodeAt(0) - 65248)
			);
			const numericValue = value;
			if (!isNaN(numericValue)) {
				model.value = numericValue.toString();
			} else {
				input.value = "";
				model.value = "";
			}
		}
	}
	titleActive.value = false;
}
/* ---------------------------------------------------------------------------
	捕捉事項の表示
---------------------------------------------------------------------------- */
function inputFocus() {
	titleActive.value = true;
}

/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(model.value);
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.input {
	min-height: 40px;
	font-size: 1.4rem;
	position: relative;
	font-weight: normal;
	@include trans(0.3);
	padding: 3px 4px 3px;
	border-radius: 5px;
	border: 1px solid $bg-gray2;
}
.form_group {
	display: flex;
	align-items: flex-end;
}
.form_group.error .input {
	color: $baseTextColor;
	border-color: $bg-red2;
	background-color: rgba(250, 183, 195, 0.2);
}
</style>
